import * as React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

const axios = require('axios').default;
export interface IGIFsProps {
    handleGifOnClick: any,
}

export function GIFs({ handleGifOnClick }: IGIFsProps) {
    const [gifs, setGifs] = useState([]);
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const fetchGifData = async () => {
        setError('')
        setIsLoading(true)
        try {
            const results = await axios('https://api.giphy.com/v1/gifs/trending', {
                params: {
                    api_key: process.env.REACT_APP_SECRET_NAME,
                    limit: 50
                }
            })
            setGifs(results.data.data);
            setIsLoading(false)
        }
        catch (error) {
            if (error instanceof Error) {
                setError(error.message);
            }
            setIsLoading(false)
        }
    }
    useEffect(() => {
        fetchGifData()
    }, [])




    const hanldeGIFSearch = async (e: any) => {
        setIsLoading(true)
        try {
            const results = await axios('https://api.giphy.com/v1/gifs/search', {
                params: {
                    api_key: process.env.REACT_APP_SECRET_NAME,
                    q: e.target.value,
                    limit: 15
                }
            })
            if (results.data.data.length > 0) {
                setGifs(results.data.data);
            }
            else {
                fetchGifData()
            }
            setIsLoading(false)
        }
        catch (error) {
            console.log(error);
            setIsLoading(false)
        }
    }




    return (
        <div className="h-full w-full sm:rounded-lg bg-[#F5F5F5] dark:bg-[#140D36] py-2 gif_images_box overflow-hidden">

            <div className="my-1 py-2.5 px-4 bg-[#ECEDF1] dark:bg-[#38366A] absolute w-full -top-1 sm:rounded-t-lg flex justify-start items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 grayToBlackSVG2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input type="text" name="" id="" onChange={hanldeGIFSearch}
                    placeholder="Search" className="bg-transparent h-full w-full pl-2 text-sm outline-none text-cusBlack dark:text-white" />
            </div>


            <div className="w-full h-full overflow-auto px-2 pt-8">
                {gifs.length > 0
                    ? <div className="columns-2 gap-x-1 space-y-1 ">
                        {gifs.map((gif: any, index) =>
                            <div onClick={() => handleGifOnClick(gif)} key={`gifNumb${index}`}
                                className="break-inside-avoid w-full h-full cursor-pointer" >
                                <img src={gif.images.preview_gif.url} alt="" className="w-full h-full" />
                            </div>
                        )}
                    </div>
                    :
                    <div className="w-full h-full flex justify-center items-center">
                        {isLoading
                            ? <div className="flex flex-col justify-center items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className="animate-bounce" width={48} height={39} viewBox="0 0 148 139">
                                    <defs>
                                        <clipPath id="clip-path">
                                            <rect id="Rectangle_814" data-name="Rectangle 814" width={148} height={139} transform="translate(-0.555 -0.33)" fill="#fb0" />
                                        </clipPath>
                                    </defs>
                                    <g id="Group_1121" data-name="Group 1121" transform="translate(0.555 0.33)" clipPath="url(#clip-path)">
                                        <path id="Path_662" data-name="Path 662" d="M172,342c-29.777,17.159-26.2,65.5-26.2,65.5s-13.1-4.367-13.1-24.013a53.24,53.24,0,0,0-26.2,45.847,52.4,52.4,0,0,0,104.8,0c0-42.577-39.3-51.31-39.3-87.334Zm-8.5,121.681A19.651,19.651,0,1,1,154,425.547c25.425-6.337,28.61-20.639,28.61-20.639s12.674,50.849-19.1,58.772Z" transform="translate(-90.592 -341.579)" fill="#fb0" />
                                    </g>
                                </svg>
                                <p className="mt-0 dark:text-cusBlueWhite text-l-LightBlack">Loading...</p>
                            </div>

                            : error !== '' &&
                            <div>
                                <p className="text-red-600 font-bold text-sm text-center">{error}</p>
                            </div>}
                    </div>
                }
            </div>
        </div>
    );
}